import { useState, useEffect } from "react";
import {
  validateQuestionsPerSection,
  validateSection,
} from "./useSectionValidation";

export const useAnswerManagement = (
  design: any[],
  sectionNo: number,
  formdata: any[],
  questionsPerSection: number,
  currentSection: number,
  newId: string
) => {
  const [selectedOptions, setSelectedOptions] = useState<
    Record<string, Array<string>>
  >({});
  const [answer, setAnswer] = useState<Record<string, string | Array<string>>>(
    {}
  );
  const [change, setChange] = useState(true);
  const [checkChange, setCheckChange] = useState(true);
  const [goToNextSection, setGoToNextSection] = useState(false);

  const handleCheckboxChange = (option: string, actionId: string) => {
    setSelectedOptions((prev) => {
      const current = prev[actionId] || [];
      if (current.includes(option)) {
        return {
          ...prev,
          [actionId]: current.filter((e) => e !== option),
        };
      } else {
        return {
          ...prev,
          [actionId]: [...current, option],
        };
      }
    });
  };

  const handleRatingChange = (id: string, newRating: number) => {
    setAnswer({
      ...answer,
      [id]: String(newRating),
    });
  };

  const handleRadioChange = (option: string, actionId: string) => {
    setAnswer((prev) => ({
      ...prev,
      [actionId]: prev[actionId]?.includes(option) ? [] : [option],
    }));
    setChange((prev) => !prev);
  };

  const handleUpdate = (e: any, actionId: string, j: string) => {
    if (j) {
      setAnswer((prev) => ({
        ...prev,
        [actionId]: j,
      }));
    } else {
      setAnswer((prev) => ({
        ...prev,
        [actionId]: e.target.value,
      }));
    }
  };

  // console.log("Answer", answer, setSelectedOptions);

  useEffect(() => {
    if (design?.length > 0) {
      validateSection(
        design,
        sectionNo,
        formdata,
        selectedOptions,
        answer,
        setGoToNextSection,
        newId
      );
    } else {
      validateQuestionsPerSection(
        currentSection,
        questionsPerSection,
        formdata,
        selectedOptions,
        answer,
        setGoToNextSection,
        newId
      );
    }
  }, [
    answer,
    sectionNo,
    change,
    checkChange,
    currentSection,
    formdata,
    design,
    selectedOptions,
    questionsPerSection,
  ]);

  return {
    selectedOptions,
    answer,
    goToNextSection,
    handleCheckboxChange,
    handleRadioChange,
    handleRatingChange,
    handleUpdate,
    setGoToNextSection,
  };
};
